module.exports = __webpack_public_path__ + "static/media/welcome-image.7a187ef6.svg";